// extracted by mini-css-extract-plugin
export default {"mainTitle":"InfluencerLoyalty_mainTitle__G30aw","secondLine":"InfluencerLoyalty_secondLine__wfaiw","centerText":"InfluencerLoyalty_centerText__BkxOq"};